import React, { useState } from "react";
import { ReactComponent as Logo } from "../../../../../images/icons/logo.svg";
import styles from "../../Components/shared/Shared.module.scss";
import ModalInvite from "../ModalInvite/ModalInvite";
import { Modal } from "antd";
export const MobilHeader = ({ speakers, lang }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div className={styles.MobilHeader}>
        <div className="icon">
          <Logo
            width={38}
            height={38}
            onClick={() => window.open("https://skillometer.ru/", "blank")}
          />
        </div>
        <div className={styles.MobilHeaderSettings} onClick={showModal}>
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "12px",
              backgroundColor: "#4B4F5E",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#A4A9C9"
            >
              <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
            </svg>
          </div>
          {/*<img src={settings_mobile}/>*/}
        </div>
      </div>
      <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <div style={{ display: "flex", fontSize: "16px", gap: "15px" }}>
          {speakers && <a href="#section1">{lang.variable_2}</a>}
          {speakers && <a href="#section2">{lang.variable_7}</a>}
          {speakers && <a href="#section3">{lang.variable_53}</a>}
          {speakers && <a href="#section4">{lang.variable_18}</a>}
          {speakers && <a href="#section6">{lang.variable_19}</a>}
        </div>
      </Modal>
    </>
  );
};
